export default {
  "content": "<path d=\"M9.9 4.2v3c0 .672.222 1.296.6 1.8H6.9c.39-.516.6-1.14.6-1.8v-3h2.4zM11.7 3h-6c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h.6v3c0 .996-.804 1.8-1.8 1.8v1.2h3.582v4.2l.6.6.6-.6v-4.2H12.9V9c-.996 0-1.8-.804-1.8-1.8v-3h.6c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#fff",
    "viewBox": "0 0 18 18"
  }
};